import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import './PaymentFailed.less';

const PaymentFailed = ({ onRetry }) => {
	return (
		<div className="payment-failed">
			<div className="payment-failed-header">
				<div className="error-icon-wrapper">
					<CloseCircleOutlined className="error-icon" />
				</div>
				<h2 className="payment-failed-title">Payment Failed</h2>
				<p className="payment-failed-subtitle">
					Your payment could not be processed. Please try again.
				</p>
			</div>

			<div className="error-details-section">
				<div className="order-status-badge failed">
					<span>Payment Unsuccessful</span>
				</div>

				<div className="what-to-do-next">
					<h3 className="what-to-do-title">What should you do?</h3>
					<ul className="what-to-do-list">
						<li>• Check your payment method and ensure sufficient funds</li>
						<li>• Verify your card details are correct</li>
						<li>• Try using a different payment method</li>
						<li>• Contact support if the problem persists</li>
					</ul>
				</div>
			</div>

			<div className="retry-button-section">
				<Button
					type="primary"
					size="large"
					block
					onClick={onRetry}
					className="retry-button"
				>
					Try Again
				</Button>
			</div>
		</div>
	);
};

export default PaymentFailed;
